import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('post', `/api/roundtables/${id}/join-students`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/autoJoinRoundtable.js